import React from 'react';
import { Button } from '../../../components/ui/button';
import { RefreshCw, Loader2, Database } from 'lucide-react';

export const BiginHeader = ({ formatDate, handleSync, lastSync, syncing }) => (
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div>
          <h1 className="text-2xl font-bold text-gray-900 flex items-center gap-2">
            <Database className="w-6 h-6 text-[hsl(187,70%,38%)]" />
            Zoho Bigin Pipeline
          </h1>
          <p className="text-gray-500 text-sm mt-1">
            {lastSync ? `Last synced: ${formatDate(lastSync)}` : 'Not synced yet'}
          </p>
        </div>
        <Button 
          onClick={handleSync} 
          disabled={syncing}
          className="bg-[hsl(187,70%,38%)] hover:bg-[hsl(187,70%,32%)] text-white"
          data-testid="sync-bigin-button"
        >
          {syncing ? (
            <><Loader2 className="w-4 h-4 mr-2 animate-spin" /> Syncing...</>
          ) : (
            <><RefreshCw className="w-4 h-4 mr-2" /> Sync Now</>
          )}
        </Button>
      </div>
);
